module.exports = __webpack_public_path__ + "img/browser-anfrage.bd1a766e.svg";